export enum DocumentNodeType {
  GENERAL = "GENERAL",
  PERSONAL = "PERSONAL"
}

export enum DocumentNodeTypeKey {
  GENERAL,
  PERSONAL
}
